/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function(){
  if($('.template-collection').length > 0){
    if( $('.SectionHeader__Heading').text() == "Products"){
      $(".SectionHeader__Heading").html("Shop Black");
    }
  }
})


document.addEventListener('breakpoint:changed', rebuild_flickities);

var flickityList = [];     

$(function(){
   

  if($('.Content-Slider-Flickity').length > 0){
      $('.Content-Slider-Flickity').each(function(){
      var $carousel = $(this).flickity({
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            contain: true,
            cellAlign: "center",
            dragThreshold: 8,
            freescroll : false
        })
       flickityList.push($carousel);
      
    })
  }

  if($('.Hero-Slider-Slick').length > 0){
    $('.Hero-Slider-Slick').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false
    });
  }

   if($('.Collections-Carousel-Flickity').length > 0){
      $('.Collections-Carousel-Flickity').each(function(){
      var $carousel = $(this).flickity({
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            contain: true,
            cellAlign: "left",
            dragThreshold: 8,
        
        })
       flickityList.push($carousel);
      
    })
  }
  
})

function rebuild_flickities(){
  console.log('rebuild flickities')
  flickityList.forEach(function(item){
  item.flickity('destroy');
  item.flickity({
            prevNextButtons: false,
            pageDots: false,
            wrapAround: false,
            contain: true,
            cellAlign: "left",
            dragThreshold: 8,
            freescroll : true
        })
  });
}      

/* Fix screen size change */
$(function(){
  document.addEventListener('breakpoint:changed', header_center);
});

function header_center(){
  if($(window).width() > 1008){
    $('.Header').addClass('Header--center');
  }
}

// Open external links in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

